var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-box"},[_c('div',{staticClass:"desc-box"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('clubsSummary.info.title')))]),_c('div',{staticClass:"desc"},[_vm._v(" "+_vm._s(_vm.$t('clubsSummary.info.desc'))+" ")])]),_c('img',{attrs:{"src":_vm.imgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }